import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';

export const timeZoneInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  if (timeZone) {
    req = req.clone({
      setHeaders: {
        'X-Time-Zone': timeZone,
      },
    });
  }
  return next(req);
};
